__turbopack_context__.v({
  "icon-container": "AcfStyledList-module-scss-module__akwXvG__icon-container",
  "list-item": "AcfStyledList-module-scss-module__akwXvG__list-item",
  "styled-list": "AcfStyledList-module-scss-module__akwXvG__styled-list",
  "text-container": "AcfStyledList-module-scss-module__akwXvG__text-container",
});
